var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 695 839",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-251.702,-179.891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M809.05,260.597C809.05,260.597 865.142,307.158 883.675,323.108C906.72,342.94 946.676,391.53 946.676,391.53L946.676,267.543C946.676,267.543 946.676,257.368 940.694,253.813C934.52,250.143 928.095,252.036 928.095,252.036C928.095,252.036 881.62,259.152 867.26,259.974C850.304,260.945 809.05,260.597 809.05,260.597Z",
    style: {
      fill: "rgb(124,59,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.121,547.001C263.121,547.001 274.629,709.537 364.163,816.157C489.985,965.99 600,1018.46 600,1018.46C600,1018.46 675.306,976.658 727.36,929.73C779.415,882.802 821.216,833.903 821.216,833.903C821.216,833.903 672.461,840.109 506.524,749.906C355.52,667.821 263.121,547.001 263.121,547.001Z",
    style: {
      fill: "rgb(253,120,1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,792.195L600,1018.46C600,1018.46 675.306,976.658 727.36,929.73C779.415,882.802 821.216,833.903 821.216,833.903C821.216,833.903 764.163,833.039 709.657,822.763C653.578,812.19 600,792.195 600,792.195Z",
    style: {
      fill: "rgb(124,59,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,179.891C600,179.891 526.752,240.855 450.042,252.406C323.301,271.492 272.903,250.417 272.903,250.417C272.903,250.417 268.864,248.145 261.293,252.941C253.721,257.736 254.983,263.036 254.983,263.036L251.702,390.491C251.702,390.491 308.253,536.738 480.094,651.528C709.768,804.95 868.9,772.914 868.9,772.914C868.9,772.914 909.075,698.608 928.338,605.855C949.469,504.112 946.538,442.645 946.538,442.645C946.538,442.645 881.523,364.074 857.492,340.659C833.461,317.244 742.818,250.993 742.818,250.993C742.818,250.993 709.102,244.014 669.259,224.519C629.957,205.288 600,179.891 600,179.891Z",
    style: {
      fill: "rgb(124,59,0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600,179.891L599.189,718.75C599.189,718.75 673.424,752.587 744.457,766.852C807.843,779.581 868.9,772.914 868.9,772.914C868.9,772.914 909.075,698.608 928.338,605.855C949.469,504.112 946.538,442.645 946.538,442.645C946.538,442.645 900.708,380.103 857.492,340.659C803.21,291.114 742.818,250.993 742.818,250.993C742.818,250.993 709.102,244.014 669.259,224.519C629.957,205.288 600,179.891 600,179.891Z",
    style: {
      fill: "rgb(253,120,1)"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3aea731c7b99b1ea87a0374e9083fb23.svg";
export { ForwardRef as ReactComponent };